module.exports = __webpack_public_path__ + "img/courtney-silbiger.42097005.jpg";